export interface SubscriberInfo {
    email: string;
    firstName: string;
    lastName: string;
    internetConnectionPackage: string;
};